import React, { Component } from 'react';

class Overlay extends Component {
  render() {
    const { handleActionOverlay = () => {}, styles = {}, children } = this.props;
    const { styleTop = '', zIndex = 'initial', cursor } = styles;

    return (
      <div
        className={'overlay'}
        onClick={handleActionOverlay}
        style={{
          top: styleTop,
          display: 'grid',
          placeContent: 'center',
          cursor,
          zIndex,
        }}
      >
        { children }
      </div>
    );
  }
}

export default Overlay;
